import {Directive, ElementRef, Input, OnChanges, OnInit, Renderer2, RendererStyleFlags2} from '@angular/core';
import {mostReadable, TinyColor} from "@ctrl/tinycolor";

@Directive({
    selector: '[appCustomButtonColours]',
    standalone: false
})
export class CustomButtonColoursDirective implements OnInit, OnChanges {
    @Input('appCustomButtonColours') colour!: string;

    constructor(private el: ElementRef, private renderer: Renderer2) {
    }

    ngOnInit(): void {
        this.setButton();
    }

    ngOnChanges(): void {
        this.setButton();
    }

    setButton(): void {
        let button: HTMLElement = this.el.nativeElement
        if (this.colour && button) {

            this.renderer.setStyle(button, '--button-bg-color', this.colour, RendererStyleFlags2.DashCase);

            this.renderer.setStyle(button, '--button-font-color', this.getContrastColor(this.colour), RendererStyleFlags2.DashCase);

            if (!button.classList.contains('customButtonColours')) {
                this.renderer.addClass(button, 'customButtonColours');
            }
            if (!button.classList.contains('active')) {
                this.renderer.addClass(button, 'active');
            }
        }
    }

    getContrastColor(color?: string): string {
        if (color) {
            let fallback: string = new TinyColor(color).isLight() ? 'rgba(black, 0.87)' : 'white';
            let mostReadableColor: string | undefined = mostReadable(color, ["#ffffff", "#000000", "#808080", "#C0C0C0"], {includeFallbackColors: true})?.toHexString()
            if (!mostReadableColor) {
                mostReadableColor = fallback;
            }
            return mostReadableColor
        } else {
            return 'var(--accent-text)'
        }
    }
}
